import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isMobile} from '../../v2/selectors/DeviceSelectors';

export function RenderOnPresentational(props) {
  if (props.render) return props.children;
  return null;
}

RenderOnPresentational.propTypes = {
  render: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

RenderOnPresentational.defaultProps = {
  render: false,
};

const mapStateToProps = (state, ownProps) => ({
  render: (isMobile(state) && ownProps.mobile)
    || (!isMobile(state) && ownProps.desktop),
});

const RenderOn = connect(mapStateToProps)(RenderOnPresentational);

const checkProps = (props) => {
  if (!props.mobile && !props.desktop) {
    return new Error('Either \'mobile\' or \'desktop\' required otherwise it won\'t render.');
  }
};

RenderOn.propTypes = {
  mobile: checkProps,
  desktop: checkProps,
};

export default RenderOn;
